import { catalog } from "../i18n.js";

/** A bot's face and the picker that sets it (components/Avatar.tsx, AvatarPicker.tsx). */
export const AVATAR = catalog(
  {
    shapeCircle: "Circle",
    shapeRounded: "Rounded",
    shapeSquare: "Square",
    shapeOval: "Oval",
    shapeHexagon: "Hexagon",
    shapeTriangle: "Triangle",
    shapeStar: "Star",
    shapeHeart: "Heart",

    avatar: "Avatar",
    wrongType: "An avatar must be a PNG, JPEG, WebP or GIF.",
    shape: "Shape",
    mark: "Mark",
    upload: "Upload",
    reset: "Reset",
    resetTitle: "Back to the initials on a colour of its own",
    label: "Label",
    colour: "Colour",
    colourOf: (swatch: string) => `Colour ${swatch}`,
    uploading: "Uploading…",
    dropImage: "Drag, drop, or paste an image",
    or: "or",
    browse: "Browse files",
    dragTitle: "Drag the picture; it may sit partly outside the frame",
    zoom: "Zoom",
    replace: "Replace picture",
    cancel: "Cancel",
    setAvatar: "Set avatar",
    changeAvatar: "Change the avatar",
  },
  {
    shapeCircle: "Lingkaran",
    shapeRounded: "Membulat",
    shapeSquare: "Persegi",
    shapeOval: "Oval",
    shapeHexagon: "Segi enam",
    shapeTriangle: "Segitiga",
    shapeStar: "Bintang",
    shapeHeart: "Hati",

    avatar: "Avatar",
    wrongType: "Avatar harus berupa PNG, JPEG, WebP, atau GIF.",
    shape: "Bentuk",
    mark: "Inisial",
    upload: "Unggah",
    reset: "Atur ulang",
    resetTitle: "Kembali ke inisial dengan warnanya sendiri",
    label: "Label",
    colour: "Warna",
    colourOf: (swatch: string) => `Warna ${swatch}`,
    uploading: "Mengunggah…",
    dropImage: "Seret, lepas, atau tempel gambar",
    or: "atau",
    browse: "Pilih file",
    dragTitle: "Geser gambarnya; boleh sebagian di luar bingkai",
    zoom: "Perbesar",
    replace: "Ganti gambar",
    cancel: "Batal",
    setAvatar: "Pakai avatar",
    changeAvatar: "Ganti avatar",
  },
);
